<template>
    <div>
        <yandex-map
            :behaviors="['drag', 'dblClickZoom', 'multiTouch']"
            :cluster-options="{1: {clusterDisableClickZoom: true}}"
            :controls="['default']"
            :coords="mapCenter"
            map-type="hybrid"
            style="width: 100%; height: 85vh;"
            :zoom="12"
            @map-was-initialized="mapInit"
        >
            <ymap-marker
                v-for="(mapPlaceMark, mapPlaceMarkIndex) in mapPlaceMarks"
                :key="`mapPlaceMark_${mapPlaceMarkIndex}`"
                :markerId="mapPlaceMark.id"
                marker-type="placemark"
                :coords="mapPlaceMark.coords"
                hint-content="Hint content 1"
                :icon="{color: 'blue'}"
                :cluster-name="mapPlaceMark.clusterName"
            />
        </yandex-map>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        forEach as _forEach,
        map as _map,
    } from 'lodash'

    import { yandexMap, ymapMarker } from 'vue-yandex-maps'

    export default {
        name: 'StationsOnMap',

        components: {
            yandexMap,
            ymapMarker,
        },

        props: {
            _stations: Array,
            mapCenter: Array,
        },

        data() {
            return {
                mapZoom: 12,
            }
        },

        computed: {
            ...mapGetters({
                getStations: 'station/getStations',
            }),

            mapPlaceMarks() {
                const mapPlaceMarks = []

                _forEach(this.getStations, Station => {
                    if (Station.coordinates) {
                        mapPlaceMarks.push({
                            id: Station.id,
                            coords: Station.coordinates,
                            properties: {}, // define properties here
                            options: {}, // define options here
                            clusterName: '1',
                            callbacks: {
                                click: function () {
                                },
                            },
                        })
                    }
                })
                return mapPlaceMarks
            },

        },

        mounted() {
            //
        },

        methods: {
            mapInit(instance) {
                instance.setCenter(_map(this.mapCenter, point => parseFloat(point)), 12, {
                    checkZoomRange: true,
                })
            },
        },
    }
</script>
